/*
 * hellopanda-scrollbutton
 */
const HELLOPANDA_SCROLLBUTTON = {
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function() {

      _.add_event_scrollto();
      _.observer_scroll_section();

    });
  },
  add_event_scrollto: function() {
    const _ = this;

    const scrollbuttonArray = document.querySelectorAll('.wp-block-hellopanda-scroll-button-block');
    scrollbuttonArray.forEach(scrollButton => {
      const scrollId = scrollButton.dataset.id;
      const scrollGap = parseFloat(scrollButton.dataset.gap || 0) || 0;
      const scrollSpeed = parseFloat(scrollButton.dataset.speed || 0) || 0;
      const scrollHash = scrollButton.dataset.hash || '';
      if (scrollId) {
        const scrollToElement = scrollHash ? document.querySelector(`${scrollHash}`) : '';
        if (!scrollToElement) {
          return;
        }
        scrollButton.addEventListener('click', function (e) {
          history.pushState(null, '', scrollHash);
          _.go_to_scroll(scrollToElement, scrollGap, scrollSpeed);
        });
      }
    });

  },
  go_to_scroll: function(scrollToElement, scrollGap, scrollSpeed) {
    const _ = this;

    let animationFrameId = null;

    const targetY = scrollToElement.getBoundingClientRect().top + window.pageYOffset - scrollGap;
  
    if (!scrollSpeed || scrollSpeed <= 0) {
      window.scrollTo(0, targetY);
      return;
    }
  
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const duration = scrollSpeed;
    const startTime = performance.now();
  
    const easing = t => t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  
    const cancelOnUserScroll = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
        removeListeners();
      }
    };
  
    const addListeners = () => {
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(type =>
        window.addEventListener(type, cancelOnUserScroll, { passive: true, once: true })
      );
    };
  
    const removeListeners = () => {
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(type =>
        window.removeEventListener(type, cancelOnUserScroll)
      );
    };

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easing(progress);

      window.scrollTo(0, startY + distance * easedProgress);
  
      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animate);
      } else {
        animationFrameId = null;
        removeListeners();
      }
    }
  
    addListeners();
    animationFrameId = requestAnimationFrame(animate);

  },
  observer_scroll_section: function() {
    const _ = this;

    const scrollElements = [];
    const scrollbuttonArray = document.querySelectorAll('.wp-block-hellopanda-scroll-button-block');
    
    // 감지할 대상 요소 수집
    scrollbuttonArray.forEach(scrollButton => {
      const scrollHash = scrollButton.dataset.hash || '';
      if (scrollHash) {
        const scrollTarget = document.querySelector(`${scrollHash}`);
        if (scrollTarget) {
          scrollElements.push(scrollTarget);
        }
      }
    });
    
    // 캐싱용
    const entryMap = new Map();

    // IntersectionObserver 정의
    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach(entry => {
          entryMap.set(entry.target, entry); // 대상별 최신 상태 저장
        });

        const visibleEntries = Array.from(entryMap.values())
        .filter(entry => entry.isIntersecting)
        .sort((a, b) => {
          const aFull = a.intersectionRatio === 1;
          const bFull = b.intersectionRatio === 1;
    
          if (aFull && !bFull) return -1;
          if (!aFull && bFull) return 1;
    
          return b.intersectionRect.height - a.intersectionRect.height;
        });

        // 먼저 모든 요소에서 active 제거
        scrollbuttonArray.forEach(btn => btn.classList.remove('active'));
    
        // 가장 많이 보이는 하나만 active 부여
        if (visibleEntries.length > 0) {
          const targetElement = visibleEntries[0].target;
          const sectionId = targetElement ? targetElement.id : '' ;
          const targetButtons = document.querySelectorAll(`.wp-block-hellopanda-scroll-button-block[data-hash="#${sectionId}"]`);
          targetButtons.forEach(targetButton => {
            targetButton.classList.add('active');
          });
        }
      },
      { 
        root: null, // 보통은 null로 해서 뷰포트를 기준으로 함
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        rootMargin: '0px 0px 0px 0px',
        trackVisibility: true,
        delay: 100,
      }
    );
    
    // 관찰 시작
    scrollElements.forEach(el => observer.observe(el));

  }
};
HELLOPANDA_SCROLLBUTTON.init();